import { render, staticRenderFns } from "./EmptyNode.vue?vue&type=template&id=a06159de"
import script from "./EmptyNode.vue?vue&type=script&lang=js"
export * from "./EmptyNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports